var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66536 15.3333H38.332V40.2499C38.332 41.3085 37.4739 42.1666 36.4154 42.1666H9.58203C8.52349 42.1666 7.66536 41.3085 7.66536 40.2499V15.3333ZM13.4154 9.58325V5.74992C13.4154 4.69138 14.2735 3.83325 15.332 3.83325H30.6654C31.7239 3.83325 32.582 4.69138 32.582 5.74992V9.58325H42.1654V13.4166H3.83203V9.58325H13.4154ZM17.2487 7.66659V9.58325H28.7487V7.66659H17.2487ZM17.2487 22.9999V34.4999H21.082V22.9999H17.2487ZM24.9154 22.9999V34.4999H28.7487V22.9999H24.9154Z",
    fill: "#D50032"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.c56ebab9bf8d2bc097421e9ab5722a56.svg";
export { ForwardRef as ReactComponent };